/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */
export default [
  {
    width: 180,
    label: '姓名',
    tip: '请输入关键字',
    key: 'fullName',
    id: 'fullName',
    slot: 'input'
  },
  {
    width: 180,
    label: '手机号',
    tip: '请输入手机号',
    key: 'phone',
    id: 'phone',
    slot: 'input'
  }
];
